import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ComposerIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 6V18" stroke={fillColor || '#48484B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 9C5 7.89543 5.89543 7 7 7H13V17H7C5.89543 17 5 16.1046 5 15V9Z" fill={fillColor || '#48484B'} />
      <path
        opacity="0.3"
        d="M19 15C19 16.1046 18.1046 17 17 17L13 17L13 7L17 7C18.1046 7 19 7.89543 19 9L19 15Z"
        fill={fillColor || '#48484B'}
      />
    </svg>
  );
};

export { ComposerIcon };
